import { IActionEventsInitConfig } from '../interfaces/IMarketingEntryPointParams'
import { loadWidgetLoader } from './widgetLoader'

function setWidgetLoaderEnvironment(env: string) {
  const widgetLoader = (window as any).WidgetLoader

  switch (env) {
    case 'prod':
      widgetLoader.prod()
      break
    case 'rc':
      widgetLoader.rc()
      break
    case 'dev':
      widgetLoader.dev()
      break
    case 'stable':
      widgetLoader.stable()
      break
    default:
      console.warn(`Unknown environment: ${env}. Falling back to prod.`)
      widgetLoader.prod()
  }
}

function marketingEntryPointConnect(params: IActionEventsInitConfig) {
  const { env } = params

  setWidgetLoaderEnvironment(env)
  ;(window as any).WidgetLoader.load({ name: 'marketingEntryPoint' }, () => {
    marketingEntryPointInit(params)
  })
}

export function connectMarketingEntryPoint(params: IActionEventsInitConfig) {
  loadWidgetLoader(params, () => {
    marketingEntryPointConnect(params)
  })
}

function marketingEntryPointInit({ env }: IActionEventsInitConfig) {
  ;(window as any).MarketingEntryPoint.initMarketingStatistics({
    env,
  })
}
